export default __webpack_public_path__ + "static/subset-UniNeueBlack-49edad05fd0d7e4809b5adc6626f7dc8.woff";